module.exports = __webpack_public_path__ + "static/media/performance.5a7c8bba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/maps/performance.svg
// module id = 962
// module chunks = 0